import { render, staticRenderFns } from "./NAO_Descargables.vue?vue&type=template&id=96b96c40&"
import script from "./NAO_Descargables.vue?vue&type=script&lang=js&"
export * from "./NAO_Descargables.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports